import { Injectable } from '@angular/core';

import { EnableClassTelemetry } from 'app/services/otel.service';
import { Subscribable } from 'app/utils/subscrible';
import { SemantriaAPIService } from '../semantria-api.service';

export interface BriefIndustryPack {
  id: string;
  name: string;
  language_id: string;
  language_name: string;
  isIndustryPack: boolean;
}

export interface ExternalResource {
  external_type: string;
  external_id: string;
  external_name: string;
}

export interface AccountDetails {
  id: string;
  email: string;
  state: string;
  languages: { id: string; name: string }[];
  features: string[];
  limits: { [key: string]: number };
  license_id: string;
  name: string;
  edition_name: string;
  edition_id: string;
  registration_date: Date;
  expiration_date: Date;
  current_balance: number;
  industry_packs: BriefIndustryPack[];
  external_resources?: ExternalResource[];
  originNames?: OriginTypes[];
}

export enum OriginTypes {
  XI = 'XI',
  ESAAS = 'ESAAS',
  RT = 'RT',
  API = 'API',
  MIXED = 'MIXED',
  UPLOAD = 'UPLOAD',
  COPY = 'COPY',
}

@EnableClassTelemetry()
@Injectable()
export class SemantriaAccountService extends SemantriaAPIService {
  public sub = new Subscribable<AccountDetails>(this.getAccountDetails.bind(this));

  getAccountDetails(): Promise<AccountDetails> {
    return this.get<AccountDetails>('/details/');
  }
}
